<template>
	<div class="app-box">
		<div class="app-circle app-circle_small left"></div>
		<div class="app-circle app-circle_normal left"></div>
		<div class="app-circle app-circle_big left"></div>
		<span class="app-text" v-if="$slots.default"><slot></slot></span>
		<div class="app-circle app-circle_big right"></div>
		<div class="app-circle app-circle_normal right"></div>
		<div class="app-circle app-circle_small right"></div>
	</div>
</template>
<script lang="js">
export default {
	name: "CircleTitle"
};
</script>

<style lang="scss" scoped>
.app-circle {
  &_small {
    $size: 15px;
    width: $size;
    height: $size;
    border-radius: 50%;
    &.right {
      margin-left: 2px;
    }
    &.left {
      margin-right: 2px;
    }
  }
  &_normal {
    $size: 20px;
    width: $size;
    height: $size;
    border-radius: 50%;
    &.right {
      margin-left: 1px;
    }
    &.left {
      margin-right: 1px;
    }
  }
  &_big {
    $size: 30px;
    width: $size;
    height: $size;
    border-radius: 50%;
    &.right {
      margin-left: 0.5px;
    }
    &.left {
      margin-right: 0.5px;
    }
  }
  &.left {
    background: linear-gradient(#84A1F5, #507AF4);
  }
  &.right {
    background: linear-gradient(#507AF4, #84A1F5);
  }
}
.app-text {
  margin: 0 19px;
  font-size: 24px;
  font-weight: bolder;
}
.app-box {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
